import { fullAddress } from "@repo/helpers";
import { Marker } from "@repo/ui";

export const defaultPinImage = "/Content/Map/map-pin-black.png";

export interface PinStyle {
	color: string;
	image: string;
	ordinal: number;
	scale: number;
}

export interface MarkerSource {
	id: number | string;
	name: string;
	lat: number;
	lon: number;
	code?: string;
	address1?: string;
	address2?: string;
	city?: string;
	stateName?: string;
	zip?: string;
}

export function mapObjToMarker(source: MarkerSource, pin: PinStyle): Marker {
	return {
		id: source.id,
		datetime: new Date(),
		lat: source.lat,
		lon: source.lon,
		ordinal: pin.ordinal,
		tooltip: source.code ? `${source.name} (${source.code})` : source.name,
		label: [
			{
				Name: source.name,
				...(source.code ? { Code: source.code } : {}),
				Address: fullAddress(source.address1, source.address2, source.city, source.stateName, source.zip),
			},
		],
		image: pin.image,
		color: pin.color,
		scale: pin.scale,
	};
}
